<template>
  <div>
    <div class="title-button">
      <h1>Cancellation Policies</h1>
      <router-link :to="{name:'create-cancellation'}" class="button p-3" v-if="userRole == 1"> New Cancellation </router-link>
    </div>
    
    <div class="box">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="editPolicy"
        @delete="deletePolicy"
        >
        
      </vdtnet-table>
    </div>
  </div>
</template>

<script>

import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'CancellationIndex',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    },
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'cancellations/penalties',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          },
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        // ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
        order: [[0, 'desc']]
      },
      fields: {
        days_before_start: {
          label: 'Policy Start Day'
        },
        days_before_end: {
          label: 'Policy End Day'
        },
        penalty_charge: {
          sortable: true,
          label: 'Penalty Amount',
          render: (data, type, row) => {
            return (row.penalty_type == 1 ) ? `${ data } %` : `£${ data }`
          }
        },
        tour_type: {
          sortable: true,
          label: 'Tour Type',
        },
        edit: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="javascript:void(0)" class="icon icon--more" data-action="edit">Edit</a>`
          }
        },
        delete: {
          searchable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            if (this.userRole == 1) {
              return `<a href="/cancellations/penalties/${ row.id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
            } else {
              return ''
            }
          }
        }
      },
      quickSearch: ''
    }
  },
  methods: {
    editPolicy(data)
    {
      this.$router.push({name:'cancellation-edit', params:{id:data.id}})
    },
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    deletePolicy(data) {
      this.$dialog
      .confirm('Are you sure you want to delete the cancellation policy ?')
      .then(() => {

        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'cancellations/penalties/' + data.id + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.success == true) {
            this.$refs.table.reload()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      })
    },
    resetForm(){
      this.newPolicy = {}
    }
  },
}
</script>

<style>
  button:disabled,
  button[disabled]{
    opacity: 0.6;
  }
</style>
